import { type Locale } from 'date-fns';
// eslint-disable-next-line import/no-unresolved
import * as Locales from 'date-fns/locale';

// Pick<typeof Localization, 'locale' | 'region'>

export default function getDateFnsLocale(locale: string) : Locale {
  const [langRaw,
    regionRaw] = locale.split('-');

  const lang = langRaw.toLowerCase();
  const region = regionRaw.toUpperCase();

  // e.g. en + US => enUS
  const fullKey = region ? `${lang}${region}` : lang;

  return (
    // @ts-expect-error - dynamic locale access
    Locales[fullKey] ?? Locales[lang] ?? Locales.enUS
  ) as Locale;
}
